import { db } from "@/firebase/firebaseConfig";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";

const fetchUsersWithUnreadCount = async () => {
  try {
    const usersSnapshot = await getDocs(collection(db, "users"));
    const users = usersSnapshot.docs.map((doc) => ({
      userId: doc.id,
      email: doc.data().email || "Неизвестный пользователь",
    }));

    const userChatsPromises = users.map(async (user) => {
      const chatDocRef = doc(db, "chat", user.userId);
      const chatDoc = await getDoc(chatDocRef);

      if (!chatDoc.exists()) {
        await setDoc(chatDocRef, { messages: [] });
      }

      const messagesRef = collection(db, `chat/${user.userId}/messages`);
      const unreadQuery = query(messagesRef, where("isRead", "==", false));
      const unreadSnapshot = await getDocs(unreadQuery);

      const lastMessageQuery = query(
        messagesRef,
        orderBy("timestamp", "desc"),
        limit(1),
      );
      const lastMessageSnapshot = await getDocs(lastMessageQuery);
      const lastMessage = lastMessageSnapshot.docs.length
        ? lastMessageSnapshot.docs[0].data()
        : null;

      return {
        ...user,
        unreadCount: unreadSnapshot.size,
        lastMessageTime: lastMessage ? lastMessage.timestamp.toMillis() : 0,
      };
    });

    const usersWithUnreadCount = await Promise.all(userChatsPromises);

    return usersWithUnreadCount.sort((a, b) => {
      if (b.unreadCount !== a.unreadCount) {
        return b.unreadCount - a.unreadCount; // сначала идут с непрочитанными
      }
      return b.lastMessageTime - a.lastMessageTime; // затем по дате последнего сообщения
    });
  } catch (error) {
    console.error("Ошибка при настройке чатов:", error);
    return [];
  }
};

export default fetchUsersWithUnreadCount;
